import React from 'react';
const globalConfigContext = React.createContext(undefined);
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useGlobalConfig = () => {
    const globalConfig = React.useContext(globalConfigContext);
    if (!globalConfig) {
        throw new Error('You may have forgot to render <GlobalClientConfigProvider /> because @weenat/client global config context is undefined, which is not nice.');
    }
    return globalConfig;
};
export const GlobalClientConfigProvider = ({ config, children }) => {
    return React.createElement(globalConfigContext.Provider, { value: config }, children);
};
